const API_END_POINT =
  window.location.href.includes("main") ||
  window.location.href.includes("valueinsightpro.jumpiq.com")
    ? "https://d3g8su2w1x0h24.cloudfront.net/api"
    : window.location.href.includes("staging")
    ? "https://df6u95unmcq7m.cloudfront.net/api"
    : "https://du90zu3nnvhjl.cloudfront.net/api";
    // : "https://d3g8su2w1x0h24.cloudfront.net/api";



// const API_END_POINT = "https://df6u95unmcq7m.cloudfront.net/api"
const JUMPS_REDIRECT_URL =
  window.location.href.includes("main") ||
  window.location.href.includes("valueinsightpro.jumpiq.com")
    ? "https://jumps.jumpiq.com/"
    : window.location.href.includes("staging")
    ? "https://jumpsstaging.jumpiq.com/"
    : window.location.href.includes("dev")
    ? "https://jumpsdev.jumpiq.com/"
    : "http://localhost:3001/";
    
    
export { API_END_POINT, JUMPS_REDIRECT_URL };

export const SECTTION_TOKEN = 'kmuq8h4632zkos90deea0f71kxeyvx98j5r9ncdnqh09cjasw9sh5rkdakx2hrxh'